<template>
    <header class="row no-gutters header">
        <div class="col-4 col-md-3 col-lg-4 logo-container">
            <div class="logo"></div>
        </div>
        <div class="col-8 col-md-8 col-lg-8 logo-container event-logo">
            <img v-if="eventLogo" :src="eventLogo">
        </div>
    </header>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import globals from '../helpers/constants';

const { mapState } = createNamespacedHelpers('main');

export default {
    name: 'Header',
    data() {
        return {
            banners: globals.banners
        }
    },
    computed: {
        ...mapState({
            eventLogo: state => state.video.eventData.logo
        })
    }
}
</script>
